import { Document, Page, View, Text } from '@react-pdf/renderer';
import type { WorkOrder } from '../../types/workOrder';
import { LABEL_SIZE, labelStyles, dash } from './labelStyles';
import { QrImage } from './labelPrimitives';

export const WorkOrderLabelDocument: React.FC<{ workOrder: WorkOrder; qrDataUrl: string }> = ({
  workOrder,
  qrDataUrl,
}) => (
  <Document>
    <Page size={LABEL_SIZE} style={labelStyles.page}>
      <QrImage src={qrDataUrl} />
      <View style={labelStyles.info}>
        <Text style={labelStyles.title}>{dash(workOrder.workOrderNumber)}</Text>
        <Text style={labelStyles.line}>{dash(workOrder.roastType ? workOrder.roastType.toUpperCase() : '')}</Text>
      </View>
    </Page>
  </Document>
);
